<div class="content-rail">
  <cigna-leaf-loading-spinner
    size="large"
    class="loader"
  ></cigna-leaf-loading-spinner>
  <div class="cdsso-content">
    <h3>Logging in...</h3>
    <p>You are being logged in to the CHCP site.</p>
  </div>
</div>
